module.exports = __webpack_public_path__ + "static/media/logotitle.bb52ae39.png";